import { ValidationMesssageModel } from "../ValidationMesssage";
import { ValidatorModel } from "../Validator";
import { types } from "mobx-state-tree";

const CodeValidatorMode = types.model({
  value: types.frozen(),
});

export const RequiredCodeValidatorModel = types
  .compose(ValidatorModel, CodeValidatorMode)
  .actions((self) => {
    return {
      set(value: any) {
        self.value = value;
      },
      validate() {
        if (self.value && self.value.code) return undefined;

        return ValidationMesssageModel.create({
          message: { mainKey: "general.validation.required" },
        });
      },
    };
  });
